/* eslint-disable */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

import parkingRouter from "./modules/parking";
// import seasonItemRouter from "./modules/seasonItem"
// import carDiscountRouter from './modules/carAndDiscount'
import outstandingAmount from "./modules/outstandingAmount";
import depositRouter from './modules/deposit'
import managementRouter from './modules/management'
import systemRouter from './modules/system'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    // eslint-disable-next-line quotes
    path: "/redirect",
    component: Layout,
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index"),
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
  },
  {
    path: "/auth-redirect",
    component: () => import("@/views/login/auth-redirect"),
    hidden: true,
  },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "/outstandingAmount/processPayment",
  },
  parkingRouter,
  {
    path: "/unpaidExportPrint",
    component: () => import("@/views/bill/print/SongpaBillPostPage.vue"),
    name: "unpaidExportPrint",
  },
  outstandingAmount,
  {
    path: "/seize",
    component: Layout,
    alwaysShow: true, // will always show the root menu
    name: "seize",
    meta: {
      title: "압류 관리",
      icon: "check",
    },
    children: [
      {
        path: "seizeProcess",
        component: () => import("@/views/seize/SeizeProcessMainManage.vue"),
        name: "seizeProcess",
        meta: {
          title: "압류처리",
        },
      },
      {
        path: "seizePayment",
        component: () =>
          import("@/views/seize/SeizeProcessPaymentMainManage.vue"),
        name: "seizePayment",
        meta: {
          title: "압류납부관리",
        },
      },
    ],
  },
  depositRouter,
  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/send",
    alwaysShow: true,
    name: "smsSend",
    meta: {
      title: "SMS 발송관리",
      icon: "email",
    },
    children: [
      {
        path: "unpaidSMSTemplate",
        component: () =>
          import("@/views/defaultProcess/sms/UnpaidSMSTamplateMainManage.vue"),
        name: "unpaidSMSTemplate",
        meta: {
          title: "메시지 발송",
        },
      },
      // {
      //   path: "send",
      //   component: () => import("@/views/SMS/SMSSendPost.vue"),
      //   name: "SMSsendPost",
      //   meta: { title: "메시지 발송" },
      // },
      {
        path: "send-history",
        component: () => import("@/views/SMS/SMSSendPostHistoryManage.vue"),
        name: "SMSsendManage",
        meta: { title: "메시지 발송 이력" },
      },
    ],
  },
  systemRouter,
  // {
  //   path: "/billPostPrint",
  //   component: () => import("@/views/bill/print/BillPostPrintPage.vue"),
  //   name: "billPostPrint",
  //   hidden: true,
  // },

  // 404 page must be placed at the end !!!
  // eslint-disable-next-line comma-dangle
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
